import styled from '@emotion/styled';
import { colors } from '@smartsheet/lodestar-core';
import { Title } from './Title';

export const TitleGrey = styled(Title)`
  color: ${colors.neutralDark10};
`;
